module.exports = __webpack_public_path__ + "static/img/technology04.4bbd42b0.png";